const add_form_item = {
  namespaced: true,
  state: {
    add_form_item_show: false,
    cur_form_item: {},
    select_name: 'input',
    form_item_type: 'add' // 表单项默认是新增
  },
  mutations: {
    set_add_form_item_show(state, val) {
      state.add_form_item_show = val
    },
    set_cur_form_item(state, val) {
      state.cur_form_item = val
    },
    set_select_name(state, val) {
      state.select_name = val
    },
    set_form_item_type(state, val) {
      state.form_item_type = val
    }
  },
  actions: {
  },
  getters: {
  }
}

export default add_form_item



// WEBPACK FOOTER //
// ./src/vuex/modules/add_form_item.js